var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E21BB8",
    d: "M39.75,35.048c0,2.597-2.105,4.702-4.702,4.702H4.952c-2.597,0-4.702-2.105-4.702-4.702V4.952 c0-2.597,2.105-4.702,4.702-4.702h30.096c2.597,0,4.702,2.105,4.702,4.702V35.048z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M13.397,32.57c-0.286-0.06-0.576-0.104-0.855-0.182 c-1.792-0.505-2.924-1.886-3.003-3.767c-0.082-1.943,0.131-3.858,0.87-5.678c0.477-1.174,1.169-2.19,2.33-2.811 c0.716-0.383,1.483-0.566,2.287-0.549c0.253,0.005,0.52,0.133,0.751,0.259c0.373,0.202,0.718,0.455,1.08,0.678 c2.103,1.298,4.206,1.297,6.308-0.005c0.292-0.181,0.589-0.355,0.864-0.561c0.502-0.377,1.056-0.424,1.653-0.336 c1.63,0.24,2.782,1.133,3.558,2.558c0.694,1.271,1.006,2.653,1.145,4.077c0.071,0.73,0.105,1.469,0.097,2.203 c-0.026,2.193-1.532,3.826-3.713,4.066c-0.055,0.006-0.106,0.029-0.16,0.046C22.202,32.57,17.8,32.57,13.397,32.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M20.418,7.43c0.327,0.065,0.656,0.122,0.98,0.197 c2.228,0.522,4.129,2.647,4.43,4.92c0.197,1.496-0.021,2.911-0.865,4.176c-1.123,1.681-2.676,2.66-4.731,2.798 c-2.697,0.182-4.916-1.404-5.923-3.558c-0.946-2.023-0.563-4.717,0.92-6.394c0.91-1.029,2.007-1.738,3.364-2.015 c0.231-0.047,0.464-0.084,0.697-0.125C19.666,7.43,20.042,7.43,20.418,7.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIcon);
export default __webpack_public_path__ + "static/media/member-icon.e1b11b78763616ab45a4634cfa000456.svg";
export { ForwardRef as ReactComponent };